import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "block" }
const _hoisted_3 = { class: "block-box" }
const _hoisted_4 = { class: "step-box" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { style: {"width":"100%"} }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { style: {"width":"100%"} }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { style: {"width":"100%"} }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { style: {"width":"100%"} }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = {
  class: "upload-box",
  style: {"width":"100%"}
}
const _hoisted_29 = { class: "attachment-title" }
const _hoisted_30 = {
  key: 0,
  class: "attachment-important"
}
const _hoisted_31 = { class: "attachment-tip" }
const _hoisted_32 = { class: "row row-alone" }
const _hoisted_33 = { class: "btn-group" }
const _hoisted_34 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_caseNotice = _resolveComponent("caseNotice")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_steps, {
              active: _ctx.activeStep,
              "align-center": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_step, { title: "基础资料" }),
                _createVNode(_component_el_step, { title: "案件资料" }),
                _createVNode(_component_el_step, { title: "上传附件" })
              ]),
              _: 1
            }, 8, ["active"])
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, [
              _cache[26] || (_cache[26] = _createElementVNode("div", { class: "name" }, [
                _createElementVNode("span", { class: "important" }, "*"),
                _createTextVNode(" 出险人 ")
              ], -1)),
              _createVNode(_component_el_select, {
                modelValue: _ctx.outDangerUserId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.outDangerUserId) = $event)),
                filterable: "",
                placeholder: "选择出险人",
                class: "screen-i search-type",
                onChange: _ctx.onSelectDangerous
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userList, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: index,
                      label: item.userName +
                              ' ' +
                              '(' +
                              item.idCardNo.slice(14, 18) +
                              ')' +
                              '          ' +
                              '投保时间' +
                              item.insureStartTime
                              ,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[27] || (_cache[27] = _createElementVNode("div", { class: "name" }, [
                _createElementVNode("span", { class: "important" }, "*"),
                _createTextVNode(" 出险时间 ")
              ], -1)),
              _createVNode(_component_el_date_picker, {
                "disabled-date": _ctx.handleDisableDate,
                format: "YYYY-MM-DD HH:mm:ss",
                "value-format": "YYYY-MM-DD HH:mm:ss",
                style: {"width":"100%"},
                modelValue: _ctx.date,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.date) = $event)),
                type: "datetime",
                placeholder: "请选择出险时间"
              }, null, 8, ["disabled-date", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[28] || (_cache[28] = _createElementVNode("div", { class: "name" }, [
                _createElementVNode("span", { class: "important" }, "*"),
                _createTextVNode(" 出险人手机号 ")
              ], -1)),
              _createVNode(_component_el_input, {
                placeholder: "请输入出险人手机号",
                modelValue: _ctx.outDangerPhone,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.outDangerPhone) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[29] || (_cache[29] = _createElementVNode("div", { class: "name" }, [
                _createElementVNode("span", { class: "important" }, "*"),
                _createTextVNode(" 报案人手机号码 ")
              ], -1)),
              _createVNode(_component_el_input, {
                placeholder: "请输入报案人手机号码",
                modelValue: _ctx.phone,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.phone) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[30] || (_cache[30] = _createElementVNode("div", { class: "name" }, [
                _createElementVNode("span", { class: "important" }, "*"),
                _createTextVNode(" 出险省市区 ")
              ], -1)),
              _createVNode(_component_el_cascader, {
                style: {"width":"100%"},
                placeholder: "请选择省市区",
                options: _ctx.areaList,
                modelValue: _ctx.area,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.area) = $event))
              }, null, 8, ["options", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[31] || (_cache[31] = _createElementVNode("div", { class: "name" }, [
                _createElementVNode("span", { class: "important" }, "*"),
                _createTextVNode(" 出险地点 ")
              ], -1)),
              _createVNode(_component_el_input, {
                placeholder: "请输入出险地点，如xx公司xx车间",
                modelValue: _ctx.place,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.place) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[34] || (_cache[34] = _createElementVNode("div", { class: "name" }, [
                _createElementVNode("span", { class: "important" }, "*"),
                _createTextVNode(" 事故类型 ")
              ], -1)),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_el_radio, {
                  modelValue: _ctx.accidentType,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.accidentType) = $event)),
                  label: "2",
                  size: "large"
                }, {
                  default: _withCtx(() => _cache[32] || (_cache[32] = [
                    _createTextVNode("工伤")
                  ])),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_radio, {
                  modelValue: _ctx.accidentType,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.accidentType) = $event)),
                  label: "1",
                  size: "large"
                }, {
                  default: _withCtx(() => _cache[33] || (_cache[33] = [
                    _createTextVNode("意外")
                  ])),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[38] || (_cache[38] = _createElementVNode("div", { class: "name" }, [
                _createElementVNode("span", { class: "important" }, "*"),
                _createTextVNode(" 是否有骨折 ")
              ], -1)),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_el_radio, {
                  modelValue: _ctx.hurtStatus,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.hurtStatus) = $event)),
                  label: "1",
                  size: "large"
                }, {
                  default: _withCtx(() => _cache[35] || (_cache[35] = [
                    _createTextVNode("是")
                  ])),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_radio, {
                  modelValue: _ctx.hurtStatus,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.hurtStatus) = $event)),
                  label: "2",
                  size: "large"
                }, {
                  default: _withCtx(() => _cache[36] || (_cache[36] = [
                    _createTextVNode("不是")
                  ])),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_radio, {
                  modelValue: _ctx.hurtStatus,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.hurtStatus) = $event)),
                  label: "3",
                  size: "large"
                }, {
                  default: _withCtx(() => _cache[37] || (_cache[37] = [
                    _createTextVNode("身故")
                  ])),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[41] || (_cache[41] = _createElementVNode("div", { class: "name" }, [
                _createElementVNode("span", { class: "important" }, "*"),
                _createTextVNode(" 是否住院 ")
              ], -1)),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_el_radio, {
                  modelValue: _ctx.hospitalStatus,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.hospitalStatus) = $event)),
                  label: "1",
                  size: "large"
                }, {
                  default: _withCtx(() => _cache[39] || (_cache[39] = [
                    _createTextVNode("是")
                  ])),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_radio, {
                  modelValue: _ctx.hospitalStatus,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.hospitalStatus) = $event)),
                  label: "2",
                  size: "large"
                }, {
                  default: _withCtx(() => _cache[40] || (_cache[40] = [
                    _createTextVNode("不是")
                  ])),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[44] || (_cache[44] = _createElementVNode("div", { class: "name" }, [
                _createElementVNode("span", { class: "important" }, "*"),
                _createTextVNode(" 是否手术 ")
              ], -1)),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_el_radio, {
                  modelValue: _ctx.surgeryStatus,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.surgeryStatus) = $event)),
                  label: "1",
                  size: "large"
                }, {
                  default: _withCtx(() => _cache[42] || (_cache[42] = [
                    _createTextVNode("是")
                  ])),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_radio, {
                  modelValue: _ctx.surgeryStatus,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.surgeryStatus) = $event)),
                  label: "2",
                  size: "large"
                }, {
                  default: _withCtx(() => _cache[43] || (_cache[43] = [
                    _createTextVNode("不是")
                  ])),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ])
          ], 512), [
            [_vShow, _ctx.activeStep === 0]
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_19, [
              _cache[45] || (_cache[45] = _createElementVNode("div", { class: "name" }, [
                _createElementVNode("span", { class: "important" }, "*"),
                _createTextVNode(" 受伤部位 ")
              ], -1)),
              _createVNode(_component_el_input, {
                placeholder: "请输入受伤部位",
                modelValue: _ctx.injuredArea,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.injuredArea) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _cache[46] || (_cache[46] = _createElementVNode("div", { class: "name" }, [
                _createElementVNode("span", { class: "important" }, "*"),
                _createTextVNode(" 治疗方式 ")
              ], -1)),
              _createVNode(_component_el_select, {
                modelValue: _ctx.treatmentMethod,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.treatmentMethod) = $event)),
                placeholder: "请选择治疗方式",
                class: "search-type"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.treatmentMethodList, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: index,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _cache[47] || (_cache[47] = _createElementVNode("div", { class: "name" }, [
                _createElementVNode("span", { class: "important" }, "*"),
                _createTextVNode(" 就诊医院 ")
              ], -1)),
              _createVNode(_component_el_input, {
                placeholder: "如：昆山市第一人民医院",
                modelValue: _ctx.visitHospital,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.visitHospital) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _cache[48] || (_cache[48] = _createElementVNode("div", { class: "name" }, [
                _createElementVNode("span", { class: "important" }, "*"),
                _createTextVNode(" 出险状态 ")
              ], -1)),
              _createVNode(_component_el_select, {
                modelValue: _ctx.accidentStatus,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.accidentStatus) = $event)),
                placeholder: "请选择出险状态",
                class: "search-type"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accidentStatusList, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: index,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _cache[49] || (_cache[49] = _createElementVNode("div", { class: "name" }, [
                _createElementVNode("span", { class: "important" }, "*"),
                _createTextVNode(" 诊断结果 ")
              ], -1)),
              _createVNode(_component_el_input, {
                type: "textarea",
                placeholder: "请输入诊断结果",
                maxlength: "500",
                "show-word-limit": "",
                modelValue: _ctx.diagnosisResult,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.diagnosisResult) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _cache[50] || (_cache[50] = _createElementVNode("div", { class: "name" }, [
                _createElementVNode("span", { class: "important" }, "*"),
                _createTextVNode(" 出险原因 ")
              ], -1)),
              _createVNode(_component_el_select, {
                modelValue: _ctx.accidentCause,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.accidentCause) = $event)),
                placeholder: "请选择出险原因",
                class: "search-type"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accidentCauseList, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: index,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _cache[52] || (_cache[52] = _createElementVNode("div", { class: "name" }, [
                _createElementVNode("span", { class: "important" }, "*"),
                _createTextVNode(" 当前花费 ")
              ], -1)),
              _createVNode(_component_el_input, {
                placeholder: "请输入当前花费",
                modelValue: _ctx.currentCost,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.currentCost) = $event))
              }, {
                append: _withCtx(() => _cache[51] || (_cache[51] = [
                  _createTextVNode("元")
                ])),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _cache[53] || (_cache[53] = _createElementVNode("div", { class: "name" }, [
                _createElementVNode("span", { class: "important" }, "*"),
                _createTextVNode(" 详细事故经过 ")
              ], -1)),
              _createVNode(_component_el_input, {
                type: "textarea",
                placeholder: "请输入详细事故经过",
                modelValue: _ctx.after,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.after) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _cache[56] || (_cache[56] = _createElementVNode("div", { class: "name" }, " 事故视频 ", -1)),
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_el_upload, {
                  class: "upload-demo",
                  action: _ctx.uploadAction,
                  headers: { Authorization: _ctx.Authorization },
                  "on-success": _ctx.fileSuccess,
                  "on-error": _ctx.fileEerror,
                  "show-file-list": true,
                  "file-list": _ctx.videoList,
                  limit: 3,
                  "on-remove": _ctx.fileRemove,
                  accept: ".mp4"
                }, {
                  default: _withCtx(() => _cache[54] || (_cache[54] = [
                    _createElementVNode("button", {
                      class: "btn-white-blue",
                      style: {"width":"130px","background":"#1989FA","color":"#fff"}
                    }, [
                      _createElementVNode("i", { class: "el-icon el-icon-camera" }),
                      _createTextVNode("选择文件 ")
                    ], -1)
                  ])),
                  _: 1
                }, 8, ["action", "headers", "on-success", "on-error", "file-list", "on-remove"]),
                _cache[55] || (_cache[55] = _createElementVNode("div", { class: "upload-introduce" }, " 视频时间10s-60s 视频大小不超100M ", -1))
              ])
            ])
          ], 512), [
            [_vShow, _ctx.activeStep === 1]
          ]),
          _withDirectives(_createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachmentGroups, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.type,
                class: "row attachment-row"
              }, [
                _createElementVNode("div", _hoisted_29, [
                  _createTextVNode(_toDisplayString(item.title) + " ", 1),
                  (item.important)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_30, "（重要）"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_31, _toDisplayString(item.tip), 1),
                _createVNode(_component_el_upload, {
                  action: _ctx.uploadAction,
                  headers: { Authorization: _ctx.Authorization },
                  "list-type": "picture-card",
                  multiple: "",
                  limit: 9,
                  "file-list": _ctx.getTemporary(item.type),
                  "before-upload": _ctx.imageBeforeUpload,
                  "on-success": (response, file, fileList) => _ctx.imageSuccess(item.type, response, file, fileList),
                  "on-error": _ctx.fileEerror,
                  "on-remove": (file, fileList) => _ctx.imageRemove(item.type, file, fileList),
                  accept: ".jpg,.jpeg,.png"
                }, {
                  default: _withCtx(() => _cache[57] || (_cache[57] = [
                    _createElementVNode("i", { class: "el-icon el-icon-plus" }, null, -1)
                  ])),
                  _: 2
                }, 1032, ["action", "headers", "file-list", "before-upload", "on-success", "on-error", "on-remove"])
              ]))
            }), 128))
          ], 512), [
            [_vShow, _ctx.activeStep === 2]
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              (_ctx.activeStep > 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn-white-blue btn-prev",
                    onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.onPrev && _ctx.onPrev(...args)))
                  }, "上一步"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              class: "btn",
              disabled: _ctx.submitting,
              onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.onNext && _ctx.onNext(...args)))
            }, _toDisplayString(_ctx.activeStep === 2 ? '提交' : '下一步'), 9, _hoisted_34)
          ])
        ])
      ])
    ]),
    _createVNode(_component_caseNotice, {
      show: _ctx.showNotice,
      "onUpdate:show": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.showNotice) = $event)),
      insureType: _ctx.insureType
    }, null, 8, ["show", "insureType"])
  ], 64))
}